import { j as r } from "../../../../jsx-runtime-B6kdoens.js";
import { c as i, a as u } from "../../../../index-CROKJrb5.js";
import { c as p, f as l } from "../../../../create-component-CBAeEoQ6.js";
import { Typography as x } from "../../../Typography/index.js";
import { useBrand as f } from "../../../../brand/context/index.js";
const d = i({
  base: "cur-mb-3",
  variants: {
    brand: {
      agency: "cur-text-primary",
      curology: "cur-text-brand"
    }
  }
}), y = p(
  "NavigationDropdownMenu",
  l(
    ({ as: o, children: s, className: e, title: a, ...c }, t) => {
      const n = o || "div", m = f();
      return /* @__PURE__ */ r.jsxs(
        n,
        {
          as: o,
          className: u("cur-flex cur-flex-col", e),
          ref: t,
          ...c,
          children: [
            a && /* @__PURE__ */ r.jsx(x, { className: d({ brand: m }), size: "subhead", children: a }),
            /* @__PURE__ */ r.jsx("ul", { className: "cur-mt-1 cur-flex cur-flex-col cur-gap-2", children: s })
          ]
        }
      );
    }
  )
);
export {
  y as NavigationDropdownMenu
};
//# sourceMappingURL=index.js.map
